<template>
<div class="col-12 text-left">
    <h3 class="p-2">
        <small class="text-muted">Order Pembelian</small>
    </h3>
    <div class="p-2 dropdown-divider"></div>
    <div class="row">
        <div class="form-group col-3">
            <label for="no-input">No. Transaksi</label>
            <input type="text" class="form-control" v-model="po.transactionNo" id="no-input" aria-describedby="code" disabled>
        </div>
        <div class="form-group col-3">
            <label>Tanggal</label>
            <flat-pickr class="form-control" v-model="po.date"></flat-pickr>
        </div>
        <div class="col-1">
            <label for="check-label-ppn">PPN</label>
            <input type="checkbox" class="form-control" v-model="po.isTaxable" id="isppn-input" />
        </div>
    </div>
    <div class="row">
        <app-lookup-field :model="po" :element="vendorLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
        <div class="form-group col-3">
            <select class="form-control" id="type-term" v-model = "po.termOfPayment">
                <option value="0">COD</option>
                <option value="14">14 Hari</option>
                <option value="30">30 Hari</option>
            </select>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-12">
            <label for="desc-textarea">Deskripsi</label>
            <textarea class="form-control" id="desc-textarea" v-model="po.description" rows="3"></textarea>
        </div>
    </div>
    <app-datatable :type="'input'" :newData="newDetail" :elements="dtElements" :collections="po.purchaseOrderDetail"></app-datatable>
    <div class="form-group row">
        <label for="dpp-input" class="col-1 offset-8 col-form-label text-right">DPP</label>
        <div class="col-3">
            <input type="number" class="form-control" v-model="calcDpp" id="dpp-input" readonly>
        </div>
    </div>
    <div class="form-group row">
        <label for="ppn-input" class="col-1 offset-8 col-form-label text-right">PPN</label>
        <div class="col-3">
            <input type="number" class="form-control" v-model="calcPpn" id="ppn-input" readonly>
        </div>
    </div>
    <div class="form-group row">
        <label for="pph-input" class="col-1 offset-8 col-form-label text-right">PPh</label>
        <div class="col-3">
            <input type="number" class="form-control" v-model="calcPph" id="pph-input" readonly>
        </div>
    </div>
    <div class="form-group row">
        <label for="total-input" class="col-1 offset-8 col-form-label text-right">Total</label>
        <div class="col-3">
            <input type="number" class="form-control" v-model="calcTotal" id="total-input" readonly>
        </div>
    </div>
    <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
    <button type="button" class="btn btn-outline-danger" @click="cancel">Cancel <i class="far fa-window-close"></i></button>
</div>
</template>

<script>
import api from '../../services/api'
import { purchaseOrder, purchaseOrderDetail } from '../../models/purchase'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker
    },
    data() {
        return {
            po: {
                ...purchaseOrder,
                purchaseOrderDetail: []
            },
            newDetail: purchaseOrderDetail ,
            vendorLookup: {
                id: 'vendor',
                title: 'Data Pemasok',
                type: 'form',
                apiUrl: 'vendor',
                filter: ['code', 'name'],
                fields: [
                    {
                        placeholder: 'Kode Pemasok',
                        width: 2,
                        column: 'vendorCode'
                    },
                    {
                        placeholder: 'Nama Pemasok',
                        width: 4,
                        column: 'vendorName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Kode',
                        column: 'code'
                    },
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'vendorId'
                    },
                    {
                        from: 'code',
                        to: 'vendorCode'
                    },
                    {
                        from: 'name',
                        to: 'vendorName'
                    }
                ]
            },
            dtElements: [
                {
                    title: 'Kode Barang',
                    column: 'productCode',
                    type: 'text',
                    width: 2,
                    disable: true
                },
                {
                    title: 'Nama Barang',
                    column: 'productName',
                    type: 'lookup',
                    width: 6,
                    lookup: {
                        id: 'product',
                        title: 'Data Produk',
                        type: 'table',
                        apiUrl: 'product',
                        filter: ['code', 'name', 'brand', 'partNumber'],
                        fields: [
                            {
                                placeholder: 'Product Name',
                                width: 5,
                                column: 'productName'
                            }
                        ],
                        dtElements: [
                            {
                                title: 'Kode',
                                column: 'code'
                            },
                            {
                                title: 'Nama',
                                column: 'name'
                            },
                            {
                                title: 'Merek',
                                column: 'brand'
                            },
                            {
                                title: 'Part Number',
                                column: 'partNumber'
                            },
                        ],
                        affectedField: [
                            {
                                from: 'id',
                                to: 'productId'
                            },
                            {
                                from: 'code',
                                to: 'productCode'
                            },
                            {
                                from: 'name',
                                to: 'productName'
                            },
                            {
                                from: 'brand',
                                to: 'productBrand'
                            },
                        ]
                    }
                },
                {
                    title: 'Merek',
                    column: 'productBrand',
                    type: 'text',
                    width: 3,
                    disable: true
                },
                {
                    title: 'Qty',
                    column: 'qty',
                    type: 'number',
                    width: 3,
                },
                {
                    title: 'Harga',
                    column: 'price',
                    type: 'number',
                    width: 3,
                },
                {
                    title: '@Diskon',
                    column: 'discount',
                    type: 'number',
                    width: 3,
                },
                {
                    title: 'PPN',
                    column: 'ppn',
                    type: 'number',
                    width: 3,
                },
                {
                    title: 'PPH',
                    column: 'pph',
                    type: 'number',
                    width: 3,
                },
            ]
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const poApi = api('purchase-order')
            this.po = await poApi.getWithParams(this.$route.query.id)
        }
    },
    computed: {
        calcDpp() {
            return this.po.purchaseOrderDetail.reduce((prev, curr) => prev + (curr.qty * curr.price) - curr.discount, 0)
        },
        calcPpn() {
            return this.po.purchaseOrderDetail.reduce((prev, curr) => prev + Number(curr.ppn), 0)
        },
        calcPph() {
            return this.po.purchaseOrderDetail.reduce((prev, curr) => prev + Number(curr.pph), 0)
        },
        calcTotal() {
            return this.po.purchaseOrderDetail.reduce((prev, curr) => prev + (curr.qty * curr.price) - Number(curr.discount) + Number(curr.ppn) - Number(curr.pph), 0)
        }
    },
    methods: {
        async save() {
            const poApi = api('purchase-order')
            if(this.$route.query.id !== undefined) {
                await poApi.update(this.po, this.$route.query.id)
            } else {
                await poApi.create(this.po)
            }
            this.$router.go(-1)
        },
        cancel() {
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentPo = this.po
            this.po = {
                ...currentPo,
                ...data
            }
        }
    }
}
</script>